module.exports = __webpack_public_path__ + "images/category_lp/brand_samples/pattern_new3/btn_pc_2d55f758daace54f2dd828716d507c8e.png";